export default "__VITE_ASSET__Dryw6Amr__"